import * as ActionTypes from './types.action';

export const resetNextRoute = () => ({type: ActionTypes.NAVIGATE_RESET});

export const setNextRoute = nextRoute => ({
  type: ActionTypes.SET_NEXT_ROUTE_SUCCESS,
  nextRoute,
});
